import React from "react";
import { Spinner as ChakraSpinner } from "@chakra-ui/react";
export function Spinner(props) {
    return (React.createElement(ChakraSpinner, { thickness: "4px", emptyColor: "gray.200", color: "brand.500", speed: "440ms", ...props }));
}
